import './Drenagem.scss'
import React, { useState, useEffect, useMemo } from 'react'
import { Modal, Breadcrumb, Header, Icon, Button } from 'semantic-ui-react'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import { Route } from 'react-router-dom'
import DrenagemUpload from './DrenagemUpload'
import DrenagemHome from './DrenagemHome'
import { useSubscription } from 'utils'
import Barcode from 'react-barcode'
import history from 'services/history'
import SwitchRouter from 'components/SwitchRouter'

const barcodeOptions = {
    background: 'transparent',
    displayValue: false,
    margin: 0,
    height: 70,
    width: 1.2
}

function Drenagem(props) {

    const [printFormActive, setPrintForm] = useState(false)
    const [formData, setFormData] = useState({ barcode: '0', id: null })
    const [askFormPrint, setAskFormPrint] = useState(false)
    const [confirmFormPrint, setConfirmFormPrint] = useState(false)
    const [canPrintForm, setCanPrintForm] = useState(null)

    const canPrintForm$ = useMemo(() => request({ method: 'GET', url: '/combustivel/drenagem/can-print-form' }).pipe(
        tap(({ response }) => setCanPrintForm(response))
    ), [])
    useSubscription(canPrintForm$)

    const getBarcode$ = useMemo(() =>
        request({ method: 'POST', url: '/combustivel/drenagem/print-form' }).pipe(
            tap(({ response }) => setFormData(response))
        )
        , [])
    useSubscription(getBarcode$, printFormActive)

    useEffect(() => {
        if (formData.barcode !== '0' && printFormActive && !askFormPrint) {
            window.print()
            setAskFormPrint(true)
        }
    }, [printFormActive, formData, askFormPrint])

    function handleAskFormPrint(ev) {
        const buttonClicked = ev.target.value
        setAskFormPrint(false)
        setPrintForm(false)
        if (buttonClicked === 'yes') {
            setConfirmFormPrint(true)
        }
    }

    const $confirmFormPrint = useMemo(() => request({ method: 'POST', url: '/combustivel/drenagem/confirm-form-print', body: { drenagem_id: formData.id } }).pipe(
        tap(() => history.push('/combustivel/drenagem/lancamento')),
        finalize(() => setConfirmFormPrint(false))
    ), [formData.id])
    useSubscription($confirmFormPrint, confirmFormPrint)

    return (
        <div id="combustivel-drenagem" className='style-2'>
            <Modal size='tiny' open={askFormPrint} dimmer='blurring'>
                <Modal.Header><Icon name='file alternate outline' /> Impressão do formulário</Modal.Header>
                <Modal.Content>
                    <p style={{ fontSize: 18 }}>Você conseguiu imprimir o formulário?</p>
                </Modal.Content>
                <Modal.Actions style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        positive
                        icon='check'
                        labelPosition='right'
                        content='Sim'
                        value='yes'
                        onClick={handleAskFormPrint}
                    />
                    <Button
                        negative
                        icon='x'
                        labelPosition='right'
                        content='Não'
                        value='no'
                        onClick={handleAskFormPrint}
                    />
                </Modal.Actions>
            </Modal>

            <Breadcrumb size='mini' icon='right angle' sections={[
                { key: 'home', content: 'Home', link: true },
                { key: 'combustivel', content: 'Combustível', link: true },
                { key: 'drenagem', content: 'Drenagem', active: true }
            ]} />

            <div id="content" className={printFormActive ? ' d-print-none' : ''}>
                <div className='wrapper'>
                    <div className='left'>
                        <Header size='medium' as='h2'>
                            <Icon name='rocket' />
                            <Header.Content>Drenagem de Combustível
                                <Header.Subheader style={{ fontSize: 15 }}>Menu</Header.Subheader>
                            </Header.Content>
                        </Header>

                        <div className='d-flex flex-column align-items-center mt-5'>
                            <Button style={{ width: 300 }} className='mb-3 orange-rdp' onClick={() => props.history.push('/combustivel/drenagem')}><Icon name='home' /> Início</Button>
                            <Button style={{ width: 300 }} disabled={!canPrintForm} className='mb-3 orange-rdp' onClick={() => setPrintForm(true)}><Icon name='print' /> Imprimir Formulário</Button>
                            <Button style={{ width: 300 }} className='mb-3 orange-rdp' onClick={() => props.history.push('/combustivel/drenagem/lancamento')}><Icon name='lab' /> Lançamento de Drenagem</Button>
                            {/* <Button style={{ width: 300 }} className='blue-rdp' onClick={() => props.history.push('/combustivel/drenagem/relatorio-geral')}><Icon name='file alternate outline' /> Relatório Geral</Button> */}
                        </div>
                    </div>
                    <div className="vertical-divider"></div>
                    <div className='right'>
                        <SwitchRouter>
                            <Route exact path={props.match.path} component={DrenagemHome} />
                            <Route exact path={`${props.match.path}/lancamento`} component={DrenagemUpload} />
                        </SwitchRouter>
                    </div>
                </div>
            </div>
            <div id='drenagem-form' className={printFormActive ? 'd-print-block' : null}>
                <table style={{ marginBottom: 25 }} id="head-table">
                    <tbody>
                        <tr>
                            <th>Unidade</th>
                            <td>DP 1</td>
                            <td rowSpan={3} style={{ width: 150 }}>
                                <Barcode {...barcodeOptions} value={formData.barcode} />
                            </td>
                        </tr>
                        <tr>
                            <th>Operador</th>
                            <td>Jonathan Borges</td>
                        </tr>
                        <tr>
                            <th>Emissão do Formulário</th>
                            <td>27/09/2019 09:51</td>
                        </tr>
                    </tbody>
                </table>

                <table id="content-table">
                    <thead>
                        <tr>
                            <th>Nº Tanque</th>
                            <th>Densidade</th>
                            <th>Temperatura</th>
                            <th>Início da Drenagem (hora)</th>
                            <th>Fim da Drenagem (hora)</th>
                            <th>Quantidade Comb. Drenada</th>
                            <th>Contém impurezas (Sim/Não)</th>
                            <th>Drenou tudo até ficar sem impurezas? (Sim/Não)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array(12).fill(null).map((x, i) => (
                            <tr key={i}>
                                <td></td>
                                <td style={{ width: 300 }}></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div style={{ marginTop: 25 }}>
                    <ul style={{ padding: '0 15px' }} className='info-texts'>
                        <li>Após imprimir este formulário é importante que o processo da drenagem seja iniciado no intervalo de até 1h, pois o processo é capturado pelas câmeras de forma automática. Caso o operador não possa estar fazendo a drenagem no momento, NÃO IMPRIMIR o formulário antecipadamente.</li>
                        <li>Ao preencher este formulário você comprova que realizou o processo de drenagem garantindo a qualidade do combustível de sua unidade.</li>
                    </ul>
                </div>

                <table style={{ marginTop: 25 }} id="footer-table">
                    <tbody>
                        <tr>
                            <th style={{ width: '1%', whiteSpace: 'nowrap', padding: 20 }}>Assinatura do Operador</th>
                            <td></td>
                            <td rowSpan={2} style={{ width: 150 }}>
                                <Barcode {...barcodeOptions} value={formData.barcode} />
                            </td>
                        </tr>
                        <tr>
                            <th style={{ width: '1%', whiteSpace: 'nowrap', padding: 20 }}>Assinatura do Gerente</th>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default Drenagem
